/*
  Koral Boutique - video en tarjetas de producto.

  El autoplay nativo del tema NO se toca. Este script solo agrega respaldos:

   1. CSS: anula la regla del tema que oculta el video y muestra la foto al hover.
   2. Arranca los videos visibles al primer gesto del usuario (scroll, clic, toque).
      Es el caso tipico: el navegador bloquea el autoplay hasta que interactuas.
   3. Si algo pausa un video que sigue en pantalla, lo retoma.
   4. Pausa los que quedan fuera de pantalla.

  Es aditivo: si falla, el video se reproduce igual por su cuenta.
  Diagnostico en consola:  koralVideoDebug()
*/
(function () {
  if (window.__koralCardVideo) return;
  window.__koralCardVideo = true;

  var SELECTOR = '.card__media video';
  var seen = [];

  var CSS = [
    '.media.media--hover-effect > video:first-child { opacity: 1 !important; }',
    '.card-wrapper:hover .media.media--hover-effect > video:first-child:not(:only-child),',
    '.card:hover .media.media--hover-effect > video:first-child:not(:only-child) { opacity: 1 !important; }',
    '.card-wrapper:hover .media.media--hover-effect > video + img,',
    '.card-wrapper:hover .media.media--hover-effect > video + video,',
    '.card:hover .media.media--hover-effect > video + img,',
    '.card:hover .media.media--hover-effect > video + video { opacity: 0 !important; }',
    '.card__media .media video { width: 100% !important; height: 100% !important; object-fit: cover; object-position: center center; display: block; }'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('koral-card-video-css')) return;
    var s = document.createElement('style');
    s.id = 'koral-card-video-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function visible(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > -200 && r.top < vh + 200 && r.width > 0 && r.height > 0;
  }

  function attempt(v) {
    if (!v.paused) return;
    v.muted = true;
    try {
      if (v.readyState === 0 && v.networkState === 3) v.load();
    } catch (e) {}
    var p = v.play();
    if (p && p.catch) {
      p.catch(function (err) {
        v.dataset.koralError = (err && err.name) || 'play rechazado';
      });
    } else {
      delete v.dataset.koralError;
    }
  }

  function playVisible() {
    seen.forEach(function (v) { if (visible(v)) attempt(v); });
  }

  // 2) Respaldo por gesto: la razon mas comun de que el autoplay no arranque.
  ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, playVisible, { passive: true });
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) playVisible();
  });

  // 3) Reintentos espaciados por si el elemento aun no estaba listo.
  [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(playVisible, ms); });

  var offscreen = null;
  if ('IntersectionObserver' in window) {
    offscreen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) attempt(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '200px 0px', threshold: 0 });
  }

  function init() {
    injectCss();
    var vids = document.querySelectorAll(SELECTOR + ':not([data-koral-ready])');
    if (!vids.length) return;

    Array.prototype.forEach.call(vids, function (v) {
      v.setAttribute('data-koral-ready', '1');
      seen.push(v);

      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.loop = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.removeAttribute('loading');

      // 3) Si algo lo pausa y sigue en pantalla, retomarlo.
      v.addEventListener('pause', function () {
        setTimeout(function () { if (visible(v)) attempt(v); }, 400);
      });
      v.addEventListener('canplay', function () { if (visible(v)) attempt(v); });

      attempt(v);
      if (offscreen) offscreen.observe(v);
    });
  }

  window.koralVideoDebug = function () {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (v, i) {
      out.push({
        n: i + 1,
        pausado: v.paused,
        visible: visible(v),
        readyState: v.readyState,
        networkState: v.networkState,
        muted: v.muted,
        autoplay: v.autoplay,
        error: v.dataset.koralError || null
      });
    });
    console.table(out);
    return out;
  };

  if ('MutationObserver' in window) {
    new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', playVisible);
  document.addEventListener('shopify:section:load', init);
})();
